import React from 'react';
import {
  Row, Col, Container, Button
} from 'react-bootstrap';
import ReactPlayer from 'react-player';
import { LinkContainer } from 'react-router-bootstrap';
import { Tron } from './Tron';

export const InstallGuides = () => {
  
  
  return (
    
    <Container>
      {/*<SubNav>*/}
      {/*  <NavLink href="/MacOs"><span style={{ paddingRight: 3, paddingLeft: 3 }}>MacOs</span></NavLink>*/}
      {/*  <NavLink href="Windows"><span style={{ paddingRight: 3, paddingLeft: 3 }}>Windows</span></NavLink>*/}
      {/*  <NavLink href="Ios"><span style={{ paddingRight: 3, paddingLeft: 3 }}>iOS</span></NavLink>*/}
      {/*  <NavLink href="ExcelOnline"><span style={{ paddingRight: 3, paddingLeft: 3 }}>Excel Online</span></NavLink>*/}
      {/*  <NavLink href="APIBackendWindows"><span*/}
      {/*    style={{ paddingRight: 3, paddingLeft: 3 }}>Caching API for Windows</span></NavLink>*/}
      {/*  <NavLink href="APIBackendMacOs"><span*/}
      {/*    style={{ paddingRight: 3, paddingLeft: 3 }}>Caching API for MacOs</span></NavLink>*/}
      {/*</SubNav>*/}
      <Container>
        <Row>
          <h2>These Install Guides will help you get going.</h2>
        </Row>
        <Row>
          <Col md={4}>
            <h2>MacOs Install Guide</h2>
            <p>Installation document for MacOs</p>
            <LinkContainer to="/MacOs">
              <Button variant='secondary'>View details</Button>
            </LinkContainer>
          </Col>
          <Col md={4}>
            <h2>Windows Install Guide</h2>
            <p>Installation document for Windows</p>
            <LinkContainer to="/Windows">
              <Button variant='secondary'>View details</Button>
            </LinkContainer>
          </Col>
          <Col md={4}>
            <h2>iOS Install Guide</h2>
            <p>Installation document for iOS</p>
            <LinkContainer to="/ios">
              <Button variant='secondary'>View details</Button>
            </LinkContainer>
          </Col>
          <Col md={4} style={{ paddingTop: '40px' }}>
            <h2>Online Install Guide</h2>
            <p>Installation document for Excel Online</p>
            <LinkContainer to="/ExcelOnline">
              <Button variant='secondary'>View details</Button>
            </LinkContainer>
          </Col>
          <Col md={4} style={{ paddingTop: '40px' }}>
            <h2>Caching API Guide Windows</h2>
            <p>Installation document for the Windows Caching API</p>
            <LinkContainer to="/APIBackendWindows">
              <Button variant='secondary'>View details</Button>
            </LinkContainer>
          </Col>
          <Col md={4} style={{ paddingTop: '40px' }}>
            <h2>Caching API Guide MacOs</h2>
            <p>Installation document for the MacOs Caching API</p>
            <LinkContainer to="/APIBackendMacOs">
              <Button variant='secondary'>View details</Button>
            </LinkContainer>
          </Col>
        </Row>
      
      </Container>
    </Container>
  );
};

